/* Great Lakes Lavender Farm — Page Kit runtime (window.GK)
   Shared helpers for GLLF landing pages and tools. No dependencies. */
(function () {
  'use strict';
  if (window.GK && window.GK.__v) return;
  document.documentElement.classList.add('gk-js');

  var GK = { __v: 1 };
  var NS = 'gk:';

  GK.$ = function (sel, root) { return (root || document).querySelector(sel); };
  GK.$$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  GK.esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  GK.debounce = function (fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms || 200); }; };
  GK.clamp = function (n, a, b) { return Math.min(b, Math.max(a, n)); };
  GK.num = function (v, d) { var n = parseFloat(String(v).replace(/[^0-9.\-]/g, '')); return isFinite(n) ? n : (d || 0); };
  GK.fmt = function (n, dp) { return Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: dp == null ? 0 : dp, minimumFractionDigits: dp || 0 }); };
  GK.money = function (n, dp) { return Number(n || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: dp == null ? 0 : dp, minimumFractionDigits: dp == null ? 0 : dp }); };

  /* ---------- storage (never throws) ---------- */
  GK.store = {
    get: function (k, d) { try { var v = localStorage.getItem(NS + k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(NS + k, JSON.stringify(v)); } catch (e) {} return v; },
    del: function (k) { try { localStorage.removeItem(NS + k); } catch (e) {} }
  };
  function sget(k) { try { var v = sessionStorage.getItem(NS + k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(NS + k, JSON.stringify(v)); } catch (e) {} }

  /* ---------- dates ---------- */
  GK.MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  GK.MONTHS_LONG = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  GK.addDays = function (d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; };
  GK.dayOfYear = function (d) { var s = new Date(d.getFullYear(), 0, 1); return Math.round((d - s) / 864e5) + 1; };
  GK.fromDoy = function (doy, year) { return GK.addDays(new Date(year || new Date().getFullYear(), 0, 1), doy - 1); };
  GK.mmdd = function (s, year) { // " 04/29" -> Date
    var m = String(s || '').trim().match(/^(\d{1,2})\/(\d{1,2})$/); if (!m) return null;
    return new Date(year || new Date().getFullYear(), +m[1] - 1, +m[2]);
  };
  GK.fdate = function (d, opts) { return d ? d.toLocaleDateString('en-US', opts || { month: 'short', day: 'numeric' }) : '—'; };
  GK.fdateLong = function (d) { return GK.fdate(d, { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' }); };
  GK.iso = function (d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); };
  GK.parseIso = function (s) { var m = String(s || '').match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; };
  GK.daysBetween = function (a, b) { return Math.round((b - a) / 864e5); };

  /* ---------- location: ZIP -> zone + coordinates ---------- */
  // Reads the site-wide destination saved by other GLLF tools, if any.
  GK.destination = function () {
    var out = {};
    try {
      var raw = localStorage.getItem('gllf_destination_v1');
      if (raw) { try { var p = JSON.parse(raw); out = (p && typeof p === 'object') ? p : { zone: p }; } catch (e) { out = { zone: raw }; } }
    } catch (e) {}
    var mine = GK.store.get('place', null);
    return Object.assign({}, out, mine || {});
  };
  GK.lookupZip = function (zip) {
    zip = String(zip || '').trim().slice(0, 5);
    if (!/^\d{5}$/.test(zip)) return Promise.reject(new Error('Enter a 5-digit US ZIP code.'));
    var cached = sget('zip:' + zip); if (cached) return Promise.resolve(cached);
    var zoneP = fetch('https://phzmapi.org/' + zip + '.json').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    var placeP = fetch('https://api.zippopotam.us/us/' + zip).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return Promise.all([zoneP, placeP]).then(function (res) {
      var z = res[0], p = res[1];
      var place = p && p.places && p.places[0];
      var lat = place ? +place.latitude : (z && z.coordinates ? +z.coordinates.lat : NaN);
      var lon = place ? +place.longitude : (z && z.coordinates ? +z.coordinates.lon : NaN);
      if (!isFinite(lat) && !(z && z.zone)) throw new Error('We could not find that ZIP code.');
      var out = { zip: zip, zone: z ? z.zone : '', tempRange: z ? z.temperature_range : '', lat: lat, lon: lon,
        city: place ? place['place name'] : '', state: place ? place['state abbreviation'] : '' };
      sset('zip:' + zip, out); GK.store.set('place', out);
      document.dispatchEvent(new CustomEvent('gk:place', { detail: out }));
      return out;
    });
  };
  GK.zoneNum = function (zone) { var m = String(zone || '').match(/(\d{1,2})([ab])?/i); return m ? (+m[1] + (m[2] && m[2].toLowerCase() === 'b' ? .5 : 0)) : NaN; };
  GK.PICKUP_ONLY_SOIL_STATES = ['AZ', 'CA', 'HI', 'ID', 'NV', 'OR', 'UT', 'WA']; // soil plants: pickup only; bare root can ship

  /* ---------- climate: NOAA NCEI 1991–2020 normals (public domain) ---------- */
  var NCEI = 'https://www.ncei.noaa.gov/access/services/';
  var FROST_TYPES = ['ANN-TMIN-PRBLST-T32FP10', 'ANN-TMIN-PRBLST-T32FP50', 'ANN-TMIN-PRBLST-T32FP90',
    'ANN-TMIN-PRBFST-T32FP10', 'ANN-TMIN-PRBFST-T32FP50', 'ANN-TMIN-PRBFST-T32FP90',
    'ANN-TMIN-PRBLST-T28FP50', 'ANN-TMIN-PRBFST-T28FP50', 'ANN-TMIN-PRBGSL-T32FP50'];
  function hav(a, b, c, d) { var R = 3958.8, r = Math.PI / 180, x = Math.sin((c - a) * r / 2), y = Math.sin((d - b) * r / 2); var h = x * x + Math.cos(a * r) * Math.cos(c * r) * y * y; return 2 * R * Math.asin(Math.sqrt(h)); }
  function stationsNear(lat, lon, deg) {
    var bbox = [(lat + deg).toFixed(3), (lon - deg).toFixed(3), (lat - deg).toFixed(3), (lon + deg).toFixed(3)].join(',');
    var url = NCEI + 'search/v1/data?dataset=normals-annualseasonal-1991-2020&bbox=' + bbox + '&limit=40&dataTypes=ANN-TMIN-PRBLST-T32FP50';
    return fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      return (j.results || []).map(function (x) {
        var s = x.stations && x.stations[0]; var c = x.location && x.location.coordinates;
        return s && c ? { id: s.id, name: s.name, lat: c[1], lon: c[0], mi: hav(lat, lon, c[1], c[0]) } : null;
      }).filter(Boolean).sort(function (a, b) { return a.mi - b.mi; });
    });
  }
  /* Resolves { station, stationId, mi, frostFree, season (days),
       spring32:{p10,p50,p90}, fall32:{p10,p50,p90}, spring28:{p50}, fall28:{p50} } as Date objects (null if missing).
     NOAA semantics: spring32.p10 = only a 10% chance of a 32°F frost AFTER this date (the "safe" planting date);
     spring32.p90 = earlier, 90% chance of more frost after it. fall32.p10 = 10% chance the first frost comes BEFORE
     this date (early-risk date); fall32.p90 = late. p50 = median. */
  GK.frost = function (lat, lon) {
    var key = 'frost:' + (+lat).toFixed(2) + ',' + (+lon).toFixed(2);
    var cached = sget(key); if (cached) return Promise.resolve(revive(cached));
    function tryDeg(list) {
      if (!list.length) return Promise.reject(new Error('No NOAA climate station found nearby.'));
      return stationsNear(lat, lon, list[0]).then(function (st) { return st.length ? st : tryDeg(list.slice(1)); });
    }
    return tryDeg([.35, .75, 1.5]).then(function (stations) {
      var ids = stations.slice(0, 6).map(function (s) { return s.id; }).join(',');
      return fetch(NCEI + 'data/v1?dataset=normals-annualseasonal-1991-2020&format=json&stations=' + ids + '&dataTypes=' + FROST_TYPES.join(','))
        .then(function (r) { return r.json(); })
        .then(function (rows) {
          var byId = {}; (rows || []).forEach(function (r) { byId[r.STATION] = r; });
          var pick = null;
          for (var i = 0; i < stations.length; i++) {
            var r = byId[stations[i].id];
            var gsl = r ? GK.num(r['ANN-TMIN-PRBGSL-T32FP50'], -9999) : -9999;
            if (r && ((/\//.test(r['ANN-TMIN-PRBLST-T32FP50'] || '') && /\//.test(r['ANN-TMIN-PRBFST-T32FP50'] || '')) || gsl >= 355)) { pick = { st: stations[i], r: r }; break; }
          }
          if (!pick) throw new Error('Nearby stations did not report frost normals.');
          var r2 = pick.r;
          var out = {
            station: pick.st.name, stationId: pick.st.id, mi: pick.st.mi,
            spring32: { p10: r2['ANN-TMIN-PRBLST-T32FP10'], p50: r2['ANN-TMIN-PRBLST-T32FP50'], p90: r2['ANN-TMIN-PRBLST-T32FP90'] },
            fall32: { p10: r2['ANN-TMIN-PRBFST-T32FP10'], p50: r2['ANN-TMIN-PRBFST-T32FP50'], p90: r2['ANN-TMIN-PRBFST-T32FP90'] },
            spring28: { p50: r2['ANN-TMIN-PRBLST-T28FP50'] }, fall28: { p50: r2['ANN-TMIN-PRBFST-T28FP50'] },
            season: GK.num(r2['ANN-TMIN-PRBGSL-T32FP50'], NaN)
          };
          if (out.season <= -9000) out.season = NaN;
          out.frostFree = out.season >= 355 || !/\//.test(out.spring32.p50 || '');
          sset(key, out);
          return revive(out);
        });
    });
    function revive(o) {
      var y = new Date().getFullYear(); var c = JSON.parse(JSON.stringify(o));
      ['spring32', 'fall32', 'spring28', 'fall28'].forEach(function (k) { Object.keys(c[k]).forEach(function (p) { c[k][p] = GK.mmdd(c[k][p], y); }); });
      // A "first fall frost" that falls in Jan–Feb belongs to the following winter.
      ['fall32', 'fall28'].forEach(function (k) { Object.keys(c[k]).forEach(function (p) { var d = c[k][p]; if (d && d.getMonth() < 3) c[k][p] = new Date(y + 1, d.getMonth(), d.getDate()); }); });
      // A "last spring frost" in Nov–Dec belongs to the previous winter.
      ['spring32', 'spring28'].forEach(function (k) { Object.keys(c[k]).forEach(function (p) { var d = c[k][p]; if (d && d.getMonth() > 9) c[k][p] = new Date(y - 1, d.getMonth(), d.getDate()); }); });
      if (!isFinite(c.season) && c.spring32.p50 && c.fall32.p50) c.season = GK.daysBetween(c.spring32.p50, c.fall32.p50);
      return c;
    }
  };
  /* Rough zone-based fallback (median dates) when NOAA is unreachable. */
  GK.frostByZone = function (zone) {
    var z = GK.zoneNum(zone); if (!isFinite(z)) return null;
    var table = { 3: ['05-20', '09-15'], 4: ['05-12', '09-25'], 5: ['04-28', '10-10'], 6: ['04-15', '10-22'], 7: ['04-02', '11-03'], 8: ['03-18', '11-15'], 9: ['02-20', '12-05'], 10: ['01-30', '12-20'] };
    var k = GK.clamp(Math.floor(z), 3, 10); var y = new Date().getFullYear(); var t = table[k];
    var s = new Date(y + '-' + t[0] + 'T00:00:00'), f = new Date(y + '-' + t[1] + 'T00:00:00');
    if (z % 1) { s = GK.addDays(s, -7); f = GK.addDays(f, 7); }
    return { station: 'USDA zone estimate', mi: NaN, spring32: { p10: GK.addDays(s, 14), p50: s, p90: GK.addDays(s, -14) }, fall32: { p10: GK.addDays(f, -14), p50: f, p90: GK.addDays(f, 14) }, spring28: { p50: GK.addDays(s, -12) }, fall28: { p50: GK.addDays(f, 12) }, season: GK.daysBetween(s, f), estimate: true };
  };

  /* ---------- Shopify storefront data ---------- */
  GK.products = function (handle, max) {
    max = max || 1000; var key = 'col:' + handle; var cached = sget(key); if (cached) return Promise.resolve(cached);
    var all = [];
    function page(n) {
      return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + n)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) {
          var p = (j.products || []).map(function (x) {
            return { id: x.id, handle: x.handle, title: x.title, type: x.product_type, tags: x.tags, vendor: x.vendor,
              image: x.images && x.images[0] ? x.images[0].src : '', options: x.options && x.options.map(function (o) { return o.name; }),
              variants: (x.variants || []).map(function (v) { return { id: v.id, title: v.title, price: +v.price, compare: v.compare_at_price ? +v.compare_at_price : null, available: v.available, option1: v.option1 }; }) };
          });
          all = all.concat(p);
          if (p.length === 250 && all.length < max) return page(n + 1);
          sset(key, all); return all;
        });
    }
    return page(1).catch(function () { return all; });
  };
  GK.suggest = function (q, limit) {
    if (!q || q.length < 2) return Promise.resolve([]);
    var u = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + (limit || 8) + '&resources[options][unavailable_products]=last';
    return fetch(u).then(function (r) { return r.json(); }).then(function (j) {
      return ((j.resources && j.resources.results && j.resources.results.products) || []).map(function (p) {
        return { title: p.title, url: p.url, image: p.image || (p.featured_image && p.featured_image.url) || '', price: p.price, available: p.available };
      });
    }).catch(function () { return []; });
  };
  GK.img = function (src, w) { if (!src) return ''; return src.replace(/(\.[a-z]{3,4})(\?|$)/i, '_' + (w || 400) + 'x$1$2'); };

  /* ---------- files: download, calendar ---------- */
  GK.download = function (name, text, mime) {
    var blob = new Blob([text], { type: mime || 'text/plain' }); var a = document.createElement('a');
    a.href = URL.createObjectURL(blob); a.download = name; document.body.appendChild(a); a.click();
    setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 400);
  };
  function icsDate(d, allDay) {
    if (allDay) return d.getFullYear() + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0');
    return d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  }
  function icsText(s) { return String(s || '').replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/[,;]/g, function (c) { return '\\' + c; }); }
  /* events: [{title, start: Date, end?: Date, allDay?: bool, description?, location?, rrule?, alarmDays?}] */
  GK.ics = function (events, filename) {
    var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Great Lakes Lavender Farm//Grower Tools//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH'];
    events.forEach(function (e, i) {
      var allDay = e.allDay !== false && !e.timed;
      var end = e.end || (allDay ? GK.addDays(e.start, 1) : new Date(e.start.getTime() + 36e5));
      lines.push('BEGIN:VEVENT', 'UID:gllf-' + Date.now() + '-' + i + '@greatlakeslavenderfarm.com', 'DTSTAMP:' + icsDate(new Date()),
        (allDay ? 'DTSTART;VALUE=DATE:' : 'DTSTART:') + icsDate(e.start, allDay), (allDay ? 'DTEND;VALUE=DATE:' : 'DTEND:') + icsDate(end, allDay),
        'SUMMARY:' + icsText(e.title));
      if (e.description) lines.push('DESCRIPTION:' + icsText(e.description));
      if (e.location) lines.push('LOCATION:' + icsText(e.location));
      if (e.rrule) lines.push('RRULE:' + e.rrule);
      if (e.alarmDays != null) lines.push('BEGIN:VALARM', 'ACTION:DISPLAY', 'DESCRIPTION:' + icsText(e.title), 'TRIGGER:-P' + e.alarmDays + 'D', 'END:VALARM');
      lines.push('END:VEVENT');
    });
    lines.push('END:VCALENDAR');
    GK.download(filename || 'great-lakes-lavender.ics', lines.join('\r\n'), 'text/calendar');
  };
  GK.csv = function (rows, filename) {
    var t = rows.map(function (r) { return r.map(function (c) { c = String(c == null ? '' : c); return /[",\n]/.test(c) ? '"' + c.replace(/"/g, '""') + '"' : c; }).join(','); }).join('\n');
    GK.download(filename || 'export.csv', t, 'text/csv');
  };

  /* ---------- UI ---------- */
  var toastEl;
  GK.toast = function (msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'gk-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on'); clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  };
  GK.share = function (title, url) {
    url = url || location.href;
    if (navigator.share) return navigator.share({ title: title || document.title, url: url }).catch(function () {});
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () { GK.toast('Link copied'); }, function () { GK.toast(url); });
  };
  /* Opens the site's Lavender Grower assistant if present; optional prefilled question. */
  GK.openChat = function (question) {
    var btn = document.querySelector('[aria-label="Ask Lavender Grower"], [data-gllf-grower-open], .gllf-grower-launcher');
    if (!btn) { location.href = '/pages/contact'; return false; }
    btn.click();
    if (question) {
      var tries = 0; (function fill() {
        var input = document.querySelector('.gllf-grower textarea, [data-gllf-grower] textarea, [id*="grower" i] textarea, [class*="grower" i] textarea, [class*="grower" i] input[type="text"]');
        if (input) { input.value = question; input.dispatchEvent(new Event('input', { bubbles: true })); input.focus(); return; }
        if (++tries < 20) setTimeout(fill, 150);
      })();
    }
    return true;
  };
  GK.countUp = function (el, to, opts) {
    opts = opts || {}; var from = GK.num(el.dataset.gkFrom || 0), dur = opts.dur || 900, t0 = performance.now(), dp = opts.dp || 0, pre = opts.pre || '', suf = opts.suf || '';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { el.textContent = pre + GK.fmt(to, dp) + suf; return; }
    (function step(t) { var p = Math.min(1, (t - t0) / dur); var e = 1 - Math.pow(1 - p, 3); el.textContent = pre + GK.fmt(from + (to - from) * e, dp) + suf; if (p < 1) requestAnimationFrame(step); else el.dataset.gkFrom = to; })(t0);
  };
  GK.svgEl = function (tag, attrs, parent) { var el = document.createElementNS('http://www.w3.org/2000/svg', tag); Object.keys(attrs || {}).forEach(function (k) { el.setAttribute(k, attrs[k]); }); if (parent) parent.appendChild(el); return el; };

  function initTabs(root) {
    GK.$$('[data-gk-tabs]', root).forEach(function (wrap) {
      if (wrap.dataset.gkReady) return; wrap.dataset.gkReady = '1';
      var btns = GK.$$('[role="tab"]', wrap), panels = GK.$$('[role="tabpanel"]', wrap);
      function sel(i, focus) {
        btns.forEach(function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); b.tabIndex = j === i ? 0 : -1; });
        panels.forEach(function (p, j) { p.hidden = j !== i; }); if (focus) btns[i].focus();
        wrap.dispatchEvent(new CustomEvent('gk:tab', { detail: { index: i } }));
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { sel(i); });
        b.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') sel((i + 1) % btns.length, true); if (e.key === 'ArrowLeft') sel((i - 1 + btns.length) % btns.length, true); });
      });
      var start = btns.findIndex(function (b) { return b.getAttribute('aria-selected') === 'true'; });
      sel(start < 0 ? 0 : start);
    });
  }
  function initSeg(root) { // <div class="gk-seg" data-gk-seg="name"><button data-value="x">
    GK.$$('[data-gk-seg]', root).forEach(function (seg) {
      if (seg.dataset.gkReady) return; seg.dataset.gkReady = '1';
      seg.setAttribute('role', 'group');
      GK.$$('button', seg).forEach(function (b) {
        b.type = 'button'; if (!b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          GK.$$('button', seg).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          seg.dataset.value = b.dataset.value; seg.dispatchEvent(new CustomEvent('gk:change', { bubbles: true, detail: { value: b.dataset.value } }));
        });
        if (b.getAttribute('aria-pressed') === 'true') seg.dataset.value = b.dataset.value;
      });
    });
  }
  function initToggles(root) { // chips that toggle: <button class="gk-chip" data-gk-toggle>
    GK.$$('[data-gk-toggle]', root).forEach(function (b) {
      if (b.dataset.gkReady) return; b.dataset.gkReady = '1'; b.type = 'button';
      if (!b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); b.dispatchEvent(new CustomEvent('gk:change', { bubbles: true })); });
    });
  }
  function initChecklists(root) { // persist checkboxes: <ul class="gk-checklist" data-gk-persist="key">
    GK.$$('[data-gk-persist]', root).forEach(function (list) {
      if (list.dataset.gkReady) return; list.dataset.gkReady = '1';
      var key = 'check:' + list.dataset.gkPersist, state = GK.store.get(key, {});
      GK.$$('input[type="checkbox"]', list).forEach(function (c, i) {
        var id = c.value || String(i); if (state[id]) c.checked = true;
        c.addEventListener('change', function () { state[id] = c.checked; GK.store.set(key, state); list.dispatchEvent(new CustomEvent('gk:change', { bubbles: true })); });
      });
    });
  }
  function initReveal(root) {
    var els = GK.$$('[data-gk-reveal]', root); if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { var d = +(en.target.dataset.gkDelay || 0); setTimeout(function () { en.target.classList.add('is-in'); }, d); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  function initActions(root) {
    GK.$$('[data-gk-print]', root).forEach(function (b) { if (b.dataset.gkReady) return; b.dataset.gkReady = '1'; b.addEventListener('click', function () { window.print(); }); });
    GK.$$('[data-gk-share]', root).forEach(function (b) { if (b.dataset.gkReady) return; b.dataset.gkReady = '1'; b.addEventListener('click', function () { GK.share(b.dataset.gkShare || document.title); }); });
    GK.$$('[data-gk-chat]', root).forEach(function (b) { if (b.dataset.gkReady) return; b.dataset.gkReady = '1'; b.addEventListener('click', function (e) { if (GK.openChat(b.dataset.gkChat)) e.preventDefault(); }); });
  }
  GK.init = function (root) { root = root || document; initTabs(root); initSeg(root); initToggles(root); initChecklists(root); initReveal(root); initActions(root); };

  window.GK = GK;
  /* Page scripts: GK.ready(fn) runs fn once the kit is initialized. */
  GK._q = []; GK._booted = false;
  document.addEventListener('gk:ready', function () { GK._booted = true; GK._q.splice(0).forEach(function (f) { try { f(GK); } catch (err) { console.error(err); } }); });
  GK.ready = function (fn) { if (GK._booted) fn(GK); else GK._q.push(fn); };
  /* Inline section scripts run before this deferred file loads, so they queue with:
     (window.GKQ = window.GKQ || []).push(function (GK) { ... }); */
  var pending = Array.isArray(window.GKQ) ? window.GKQ : [];
  window.GKQ = { push: function (fn) { GK.ready(fn); } };
  pending.forEach(function (fn) { GK.ready(fn); });

  function boot() { GK.init(document); document.dispatchEvent(new CustomEvent('gk:ready')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { GK.init(e.target); });
})();
